export default (function (hashingString) {
  if (hashingString === void 0) {
    hashingString = '';
  }
  let hash = 0;
  if (typeof hashingString !== 'string') return '';
  const {
    length
  } = hashingString;
  if (length === 0) return hashingString;
  for (let i = 0; i < length; i += 1) {
    /* eslint-disable-next-line no-bitwise */
    hash = (hash << 5) - hash + hashingString.charCodeAt(i);
    /* eslint-disable-next-line no-bitwise */
    hash &= hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
});

// Javascript implementation of Java’s String.hashCode() method